// extracted by mini-css-extract-plugin
export default {"logo":"Head_logo__jr6FQ","head":"Head_head__rlhxw","description":"Head_description__8revV"};